import {
  Box,
  Button,
  Card,
  FormControl,
  InputLabel,
  MenuItem,
  MenuList,
  Select,
} from "@mui/material";
import { DataGrid, GridLinkOperator, GridToolbarQuickFilter } from "@mui/x-data-grid";
import React, { useState } from "react";
import { useEffect } from "react";
import { useHistory, useParams } from "react-router";
import api from "../../../../components/services/api";
import Swal from "sweetalert2";
function QuickSearchToolbar() {
  return (
    <Box
      sx={{
        p: 2,
        width: '100%',
        display: 'flex',
        justifyContent: 'end'
      }}
    >

      <GridToolbarQuickFilter
        quickFilterParser={(searchInput) =>
          searchInput
            .split(',')
            .map((value) => value.trim())
            .filter((value) => value !== '')
        }
      />
    </Box>
  );
}
export default function Survey() {
  const [data, setdata] = useState([]);
  let { id } = useParams();
  const [selected, setSelected] = useState([]);
  const history = useHistory()

  const columns = [
    {
      field: "ContainerStockType",
      headerName: "STATUS",
      width: 100,
    },

    { field: "ContainerNo", headerName: "ContainerNo", width: 150 },
    // {
    //   field: "Size",
    //   headerName: "Size",
    //   width: 300,

    // },
    {
      field: "Booking",
      headerName: "Booking",
      width: 150,
    },
    {
      field: "Size",
      headerName: "Size",
      width: 100,
    },
    {
      field: "Grade",
      headerName: "Grade",
      width: 150,
      renderCell: (params) => {
        return (
          <>
            <FormControl sx={{ width: "100%" }} size="small">
              <InputLabel>Grade</InputLabel>
              <Select
                label="Grade"
                style={{
                  width: "100%",
                }}
                value={params?.row?.Grade || ''}
                onChange={(e) => {
                  const select = data?.map((y) => {
                    y.Grade =
                      y?.ContainerNo === params?.row?.ContainerNo
                        ? e.target.value
                        : selected.filter(
                          (x) => x.ContainerNo === y?.ContainerNo
                        ).length > 0
                          ? e.target.value
                          : y?.Grade;
                    return y;
                  });

                  setdata([...select]);
                }}
                InputLabelProps={{ shrink: true }}
              >
                <MenuItem value="A">A</MenuItem>
                <MenuItem value="B">B</MenuItem>
                <MenuItem value="C">C</MenuItem>
                <MenuItem value="D">D</MenuItem>
              </Select>
            </FormControl>
          </>
        );
      },
    },
    {
      field: "Seal",
      headerName: "Survey Status",
      width: 200,
      renderCell: (params) => {
        return (
          <>
            <FormControl sx={{ width: "100%" }} size="small">
              <InputLabel>Survey Status</InputLabel>
              <Select
                label="Survey Status"
                style={{
                  width: "100%",
                }}
                disabled={params?.row?.RepairStatus === 'Processing' ? true : params?.row?.RepairStatus === 'Done' ? true : false}
                value={params?.row?.SurveyStatus || ''}
                onChange={(e) => {
                  const select = data?.map((y) => {
                    y.SurveyStatus =
                      y?.ContainerNo === params?.row?.ContainerNo
                        ? e.target.value
                        : selected.filter(
                          (x) => x.ContainerNo === y?.ContainerNo
                        ).length > 0
                          ? e.target.value
                          : y?.SurveyStatus;
                    return y;
                  });

                  setdata([...select]);
                }}
              >
                <MenuItem value='Complete'>Complete</MenuItem>
                <MenuItem value='Damage'>Damage</MenuItem>
              </Select>
            </FormControl>
          </>
        );
      },
    },
    {
      field: "JobOrderNo",
      headerName: "Job Order No",
      width: 150,
    },
    {
      field: "RepairStatus",
      headerName: "Repair Status",
      width: 200,
    },
  ];
  const getdata = async () => {
    try {
      const data = await api.get(`api/containermovement/inbound/detail/${id}`);
      const res = data?.data;
      setdata(res?.Container);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getdata();
  }, [id]);
  const handlesun = () => {
    const body = {
      VoyNo: id,
      ContainerList: data
    }
    api.post(`/api/containermovement/inbound/update/survey`, body).then((res) => {
      if (res?.meta?.status == true) {
        Swal.fire({
          title: `${res.meta.message}`,
          icon: 'success',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.isConfirmed) {
            getdata()
          }
        })
      }
    })
  }
  return (
    <>
      <Box
        sx={{
          height: 650,
          width: "100%",
        }}
      >
        <DataGrid
          getRowId={(r) => r.ContainerNo}
          rows={data}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10]}
          hideFooterSelectedRowCount
          disableColumnFilter
          disableColumnMenu
          disableColumnSelector
          disableSelectionOnClick
          checkboxSelection
          onSelectionModelChange={(ids) => {
            const selectedIDs = new Set(ids);
            const selectedRows = data?.filter((row) =>
              selectedIDs.has(row.ContainerNo)
            );
            setSelected(selectedRows);
          }}
          initialState={{
            filter: {
              filterModel: {
                items: [],
                quickFilterLogicOperator: GridLinkOperator.Or,
              },
            },
          }}
          components={{ Toolbar: QuickSearchToolbar }}
        />
      </Box>
      <Box sx={{ display: "flex", marginTop: "25px" }}>
        <Button
          sx={{ width: 80 }}
          type="button"
          variant="outlined"
          style={{
            color: "#80c340",
            borderColor: "#80c340",
            marginRight: "10px",
          }}
          onClick={history.goBack}
        >
          close
        </Button>
        <Button
          sx={{ width: 80 }}

          variant="contained"
          style={{
            background: "#80c340",
            borderColor: "#80c340",
            marginRight: "10px",
          }}
          onClick={handlesun}
        >
          Save
        </Button>
      </Box>
    </>
  );
}
